<template>
  <AppMainDrawer>
    <template #drawer>
      <DrawerStyled v-if="pageHasFilters[route.name]">
        <template #drawer-content>
          <ExpandableFilters />
        </template>
      </DrawerStyled>
    </template>
    <template #content>
      <div class="page-content">
        <LibrariesTopBar
          v-model="filterDrawerStore.open"
          :totals="totals"
        />
        <div :class="{ 'pt-4': !($route.name !== 'email') }">
          <router-view
            v-slot="{ Component }"
            @track-page-load="emit('track-page-load', $event)"
          >
            <component :is="Component" />
          </router-view>
        </div>
      </div>
    </template>
  </AppMainDrawer>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import AppMainDrawer from '@/components/shared/AppMainDrawer.vue';
import DrawerStyled from '@/components/shared/DrawerStyled.vue';
import LibrariesTopBar from '@/components/library/LibrariesTopBar.vue';
import ExpandableFilters from '@/components/filter/ExpandableFilters.vue';
import { useAppBase } from '@/stores/app/base';
import { useLibrary } from '@/stores/library/library';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';
import { useFilterDrawer } from '@/stores/filters/filterDrawer';
import { useTooltips } from '@/stores/insights/tooltips';
import { filtersTooltipKeys } from '@/helpers/constants/filtersTooltipKeys';

const router = useRouter();
const route = useRoute();

const appBaseStore = useAppBase();
const { pageHasFilters } = storeToRefs(appBaseStore);

const libraryStore = useLibrary();
const { totals } = storeToRefs(libraryStore);
const { init } = libraryStore;

const { clearPersistentFilters, setFilterConfig } = useFilters();

const { setSelectedSubMenuOption } = useSubMenu();

const filterDrawerStore = useFilterDrawer();

const { loadTooltips } = useTooltips();

const emit = defineEmits(['track-page-load']);

onMounted(async () => {
  /* set filter module so filter bar knows where to send filters */
  setFilterConfig({
    module: 'library',
    showMyJobs: route.name !== 'flagship',
    datepicker: false,
    subMenuType: null,
  });
  await init({ router });

  await loadTooltips(filtersTooltipKeys);
});

onBeforeUnmount(() => {
  clearPersistentFilters();

  setFilterConfig({
    subMenuType: null,
  });

  setSelectedSubMenuOption(null);
});
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;

  @media screen and (min-width: 1800px) {
    max-width: 1400px;
  }
}
</style>
